import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment.prod';
import { User } from '../api/user.interface';

@Injectable({
    providedIn: 'root',
})
export class UserService {
    private apiUrl = `${environment.apiUrl}/api/user`;

    constructor(private http: HttpClient) {}

    searchCustomersList(
        searchText: string,
        pageNumber: number,
        pageSize: number
    ): Observable<{ users: User[] }> {
        return this.http.get<{ users: User[] }>(
            `${this.apiUrl}/search?searchText=${searchText}&pageSize=${pageSize}&pageNumber=${pageNumber}`
        );
    }

    listUsers(body: any): Observable<any> {
        return this.http.post(`${this.apiUrl}/list-all`, body);
    }

    fetchByGroupName(
        group: string,
        pageNumber: number,
        pageSize: number
    ): Observable<User[]> {
        return this.http.get<User[]>(
            `${this.apiUrl}/find-by-group?groupName=${group}&pageNumber=${pageNumber}&pageSize=${pageSize}`
        );
    }
}
